import { render } from "./App.vue?vue&type=template&id=4d88d202"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d88d202&lang=css"

import exportComponent from "C:\\Users\\EDZ\\Desktop\\emulator\\linux_app_emulator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__